import { styles, UserAssistanceTheme, variants } from '../UserAssistanceStyles.css';
import { baseTheme } from './UserAssistanceBaseTheme.css';
import { multiVariantStyles } from './UserAssistanceVariants.css';

/*******************
 * Component Theme
 *******************/

const UserAssistanceRedwoodTheme: UserAssistanceTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { UserAssistanceRedwoodTheme };
